export default "__VITE_ASSET__SN6OQS0r__"